module.exports = __webpack_public_path__ + "static/media/lifeinsurance.0dead395.png";